import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { tableConfig } from '../../../../settings/index';
import Api from '../../../../helpers/api';
import { sendRequest } from '../../../../helpers/saga';
import { logger } from '../../../../helpers/logger';
import notifications from '../../../../redux/notifications/actions';

const api = new Api('workers/terminated');

function* loadData({ payload }) {
  try {
    const { page = 1, pageSize = tableConfig.pageSize, column, order, filter = '' } = payload;

    const result = yield call(
      sendRequest,
      api.load,
      { search: { ...payload, page, pageSize, column, order, filter } },
      notifications.REQUEST_ERROR,
      null,
      true,
    );

    if (result && result.data && result.data.success && result.data.success.data) {
      const { records: data, totalCount, filteredCount, sortableColumns, filters } = result.data.success.data;

      yield put(
        actions.loadDataSuccess({
          data,
          total: totalCount,
          filteredTotal: filteredCount,
          sortableColumns,
          filters,
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD, loadData)]);
}
